const loadScript = (src) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.src = src;
  script.defer = true;
  document.body.appendChild(script);
};

export const deferThirdPartyScripts = () => {
  const loadElfsight = () => {
    if (!document.querySelector(".elfsight-app-518f47cc-8a9f-46ba-b146-73cf303b7a23")) {
      const widget = document.createElement("div");
      widget.className = "elfsight-app-518f47cc-8a9f-46ba-b146-73cf303b7a23";
      widget.dataset.elfsightAppLazy = "";
      document.body.appendChild(widget);
    }

    loadScript("https://elfsightcdn.com/platform.js");
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadElfsight, { timeout: 6000 });
    return;
  }

  window.setTimeout(loadElfsight, 5000);
};
